// Utilities
import ReactDOM from 'react-dom'
import { useEffect } from 'react'
import { useAuthContext } from 'context'
import { useTourContext } from 'context/TourContext'

// Components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Assets
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { settings } from 'settings'

const Modal = props => {
  const {
    title,
    children,
    closeModal,
    isOpen,
    width,
    isLocked,
    isLockedMessage,
  } = props

  const hasPages = settings.pages_enabled
  const { userDetails } = useAuthContext()
  const { currentTourStep, handleFocusTour, handleNextTourStep, focusTour } =
    useTourContext()

  useEffect(() => {
    const closeModalOnEscape = event => {
      if (event.key === 'Escape' && isOpen) {
        // eslint-disable-next-line no-constant-condition
        if (false && hasPages && !userDetails?.tutorial && focusTour) {
          return
        }
        closeModal()
        if (!userDetails?.tutorial) {
          handleFocusTour()
        }
      }
    }
    document.addEventListener('keydown', closeModalOnEscape)

    return () => {
      document.removeEventListener('keydown', closeModalOnEscape)
    }
  }, [
    closeModal,
    focusTour,
    handleFocusTour,
    hasPages,
    isOpen,
    userDetails?.tutorial,
  ])

  const modal = isOpen ? (
    <div
      className={`bg-[rgba(0,0,0,0.65)] text-over-primary-background w-[100vw] h-[100svh] fixed top-0 left-0 z-[1000] flex items-center justify-center animate-opacity-fade-in`}
      onClick={closeModal}
    >
      <div
        className="bg-container-background p-5 rounded-md relative min-w-[350px] h-[fit-content] max-w-[90vw] max-h-[85svh] animate-fade-in-bottom overflow-y-auto"
        style={{ width: width ? width : 'fit-content' }}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex flex-row items-center gap-[5px]">
          <div className="flex-column">
            <h1 className="m-0 text-xl text-over-primary-background">
              {title}
            </h1>
            {isLocked ? (
              <div className="text-xs opacity-50">* {isLockedMessage}</div>
            ) : null}
          </div>
        </div>
        <FontAwesomeIcon
          icon={faXmark}
          id="close-modal-icon"
          className="cursor-pointer absolute right-5 top-5 text-over-primary-background translate-y-[3px] close-modal-icon"
          onClick={() => {
            closeModal()
            if (
              // eslint-disable-next-line no-constant-condition
              false &&
              hasPages &&
              !userDetails?.tutorial &&
              currentTourStep === 4
            ) {
              handleNextTourStep()
            }
            if (!userDetails?.tutorial) {
              handleFocusTour()
            }
          }}
        />
        {children}
      </div>
    </div>
  ) : null

  return ReactDOM.createPortal(modal, document.getElementById('modal-root'))
}

export default Modal
